import { Typography } from "antd";
import { clsx } from "clsx";
import filter from "lodash/filter";

import { Column, Row } from "Components/shared/Flexbox";

import { BaseFlowNodeContainer } from "../Shared/BaseFlowNodeContainer/BaseFlowNodeContainer";
import { BottomHandle, TopHandle } from "../Shared/FlowNodeHandles";

import type { DynamicHandle } from "Components/elements/RVFlow/constants";

import styles from "../Shared/FlowNodes.module.scss";

type NodeProps = {
    id: string;
    isConnectable: boolean;
    isSelected: boolean;
    handles: Array<DynamicHandle | undefined>;
    children: JSX.Element;
    connectingNodesFrom: string | null;
    removeNodeIcon: JSX.Element;
    className?: string;
};

export function DynamicBranchNode({
    id,
    isSelected,
    isConnectable,
    handles,
    children,
    connectingNodesFrom,
    removeNodeIcon,
    className,
}: NodeProps) {
    const activeConnectors = filter(handles, (h) => !!h?.connectorShouldDisplay)?.length || 2;
    // Wildly complex, will try to handle this more with css when we do the node style updates. basically:
    // 180 min width + (Add 40 px for each node AFTER the initial 2) + (extra padding based on node connection handles))
    const nodeWidth = 180 + 40 * (activeConnectors - 2) + (activeConnectors - 2) * 5;

    return (
        <BaseFlowNodeContainer selected={isSelected} connectingNodesFrom={!!connectingNodesFrom} className={className}>
            <>
                <TopHandle isConnectable={isConnectable} />
                {removeNodeIcon}
                <div style={{ maxWidth: "285px", width: `${nodeWidth}px` }}>{children}</div>

                <Row justifyContent="space-evenly" className={styles.branchNodeContent}>
                    {handles.map((handle, handleIndex) => {
                        // Initial values; the only time this value will be empty while the handle is displaying
                        // is on initial state
                        const connectorDisplayValue = handle?.displayValue ? `${handle?.displayValue}%` : "50%";
                        return (
                            <Column
                                key={`${id}-variant${handleIndex + 1}`}
                                alignItems="center"
                                className={clsx(styles.handleContentText, {
                                    [styles.hiddenOption]: !handle?.connectorShouldDisplay && handleIndex >= 2,
                                })}
                            >
                                <Typography.Text className={styles.optionText}>{connectorDisplayValue}</Typography.Text>
                                <BottomHandle isConnectable={isConnectable} id={`${id}-variant${handleIndex + 1}`} />
                            </Column>
                        );
                    })}
                </Row>
            </>
        </BaseFlowNodeContainer>
    );
}
